document.addEventListener("DOMContentLoaded", function () {
  $(`.hunting-slider-slick-wrapper`).slick({
    infinite: true,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next"><svg
          aria-hidden="true"
          role="img"
          aria-labelledby="icon-right-arrow-title"
          width="7"
          height="13"
          viewBox="0 0 7 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg
          style="color: #fff"
        >
          <title id="icon-right-arrow-title">Next</title>
          <path d="M1 1L6 6.5L1 12" stroke="#fff" fill="none"/>
        </svg></button>`,
    prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous"><svg
          role="img"
          aria-label="left-arrow"
          aria-labelledby="icon-left-arrow-title"
          width="7"
          height="13"
          viewBox="0 0 7 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="color: #fff"
        >
          <title id="icon-left-arrow-title">Prev</title>
          <path d="M6 1L1 6.5L6 12" stroke="#fff" fill="none"/>
        </svg></button>`,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
